import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Projects = () => {  
  return (
    <>
        
        <section class="about" id="about">
        <div class="max-width">
            {/* <h2 class="title">About us</h2> */}
            <div class="about-content">
                <div class="column left"style={{ "margin-top":"-30px" }}>
                <img src="assets/banner (2).jpg" alt="" className='ImageBanner' />
                </div>
                <div class="column right" style={{ "margin-top":"30px" }}> 
                    <div class="text1" style={{"fontWeight": "bolder","color": "#893101"  }}>INTEGRATE OUR API</div>
                    <p className=''>With our ready-to-use and developer friendly API, 
                    you can easily integrate with your website or app for FREE to start receiving payments in a breeze. 
                       and accessories outlet platform.</p>
                       <img src="assets/api.png" alt="" className='ImageApi' />
                    <div className='btnnn'>
                  <a href="https://sabuss.com/latoof6/?" className='btnRegister' >Documentation page</a>
                  </div>
                </div>
            </div>
        </div>
       
    </section>
    <div className='max-width px-3' style={{ "margin-top": "-70px" }}>    
    <div>
    <h5 className="header text-center" style={{ "font-weight": "600","color": "#893101"  }}>F.A.Qs</h5>
      <p className="text-center" style={{ "font-size": "15px", "font-weight":"600" }}>Frequently Asked Questions.</p>
      <Accordion>
        <AccordionSummary
        className='accodion'
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className='typography text-white' style={{ "font-size":"16px" }}>How Can i Buy Data?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typography text-white'>
            <div className='typo'>
            <p className='p'>1. Log in to your account</p>
          <p className='p'>2. If not click here to register</p>  
          <p className='p'>3. After log in click fund my account</p>
          <p className='p'>4. Select Coupon payment ,NB:You can buy coupon code from our agents</p>
            </div>
               
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className='accodion'
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className='typography text-white'style={{ "font-size":"16px" }}>How Do I Fund My Wallet?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typography'>
            <div className='typo'>
          <p>You can fund your wallet by clicking on fund wallet button and  use any of our Four payment means:</p>
          <p className='p'>1. Automatic funding. kindly click on generate account number</p>
          <p className='p'>2. Card Payment. You need to use you ATM card for payment</p>  
          <p className='p'>3. Bank tranfer. you can tranfer from your bank account</p>
          <p className='p'>4. SmartPay method. using opay, kuda and palmpay</p>
          </div>
               
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className='accodion'
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className='typography text-white'style={{ "font-size":"16px" }}>Can I rollover my monthly data if it stills remains?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typography text-white'>
            <div className='typo'>
          <p className='p'>Yes you can rollover with any plan under monthly mustn’t be same amount of subscription you did before but it must be under monthly.</p>
         
          </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
        className='accodion'
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className='typography text-white'style={{ "font-size":"16px" }}>What Are The Codes For Checking Data Balance?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typography'>
            <div className='typo'>
          <p className='p'>MTN-> *131*4#</p>
          <p className='p'>9mobile[Gifting]-> *228#</p>  
          <p className='p'>Airtel-> *140#</p>
          <p className='p'>Glo-> *127*0#. </p>
          </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>

    </>
  )
}

export default Projects





